export default {
      id: "common__train-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__train",
      toString: function () {
        return this.url;
      }
    }